// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"c658cfe5","703":"0e04b962","787":"a502a8dd"}[chunkId] + ".chunk.js";
};